import { Field, FieldProps } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';
import { Switch } from '@@/form-components/SwitchField/Switch';

import { useNotificationChannel } from '../useNotificationChannel';

import { ChannelFieldsProps } from './types';

export function EmailChannelFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  return (
    <div className="space-y-3">
      <Field name={`notificationChannels.${index}.config.name`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Name"
            size="vertical"
            inputId={`email-name-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`email-name-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Email Alerts"
              data-cy={`email-name-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.smtp_server`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="SMTP Server"
            size="vertical"
            inputId={`email-smtp-server-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`email-smtp-server-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="smtp.example.com:587"
              data-cy={`email-smtp-server-${channel.id}`}
              className="w-full"
            />
            <div className="text-gray-400 mt-1 text-xs italic">
              If port is not specified (e.g., example.com), defaults to port 587
            </div>
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.auth_username`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="SMTP Auth Username"
            size="vertical"
            inputId={`email-auth-username-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
          >
            <Input
              id={`email-auth-username-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="user@example.com"
              data-cy={`email-auth-username-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.auth_password`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="SMTP Auth Password"
            size="vertical"
            inputId={`email-auth-password-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
          >
            <Input
              id={`email-auth-password-${channel.id}`}
              type="password"
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="password"
              data-cy={`email-auth-password-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.require_tls`}>
        {({ field, form }: FieldProps<boolean>) => (
          <FormControl
            label="Require TLS"
            size="vertical"
            inputId={`email-require-tls-${channel.id}`}
          >
            <Switch
              id={`email-require-tls-${channel.id}`}
              checked={field.value}
              onChange={(checked) => form.setFieldValue(field.name, checked)}
              name={field.name}
              data-cy={`email-require-tls-${channel.id}`}
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.email_to`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="To Email Address"
            size="vertical"
            inputId={`email-to-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`email-to-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="alerts@example.com"
              data-cy={`email-to-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.email_from`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="From Email Address"
            size="vertical"
            inputId={`email-from-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`email-from-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="alerts@example.com"
              data-cy={`email-from-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
    </div>
  );
}
